import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Menu, Bell, Search } from 'lucide-react';
import Sidebar from './Sidebar';
import { useAuth } from '../../context/AuthContext';
import { ROLE_META } from '../../utils/roles';

export default function AppLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { user } = useAuth();
  const meta = ROLE_META[user?.role] || { label: user?.role, color: '#89CFF0' };

  return (
    <div className="app-layout">
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <div className="app-main">
        {/* Topbar */}
        <header className="topbar">
          <button
            className="btn btn-icon btn-ghost"
            onClick={() => setSidebarOpen(true)}
            style={{ display: 'none' }} /* shown via media query override */
            aria-label="Open menu"
          >
            <Menu size={18} />
          </button>

          {/* Search bar */}
          <div style={{
            display: 'flex', alignItems: 'center', gap: 8,
            padding: '6px 12px', borderRadius: 8,
            background: 'var(--surface)', border: '1px solid var(--border)',
            flex: 1, maxWidth: 340,
          }}>
            <Search size={14} style={{ color: 'var(--text-muted)', flexShrink: 0 }} />
            <input
              type="text"
              placeholder="Search…"
              style={{
                background: 'transparent', border: 'none', outline: 'none',
                fontSize: 13.5, color: 'var(--text-primary)', flex: 1,
                fontFamily: 'var(--font-ui)',
              }}
            />
            <kbd style={{
              fontSize: 10, padding: '1px 5px', borderRadius: 4,
              background: 'var(--surface-2)', border: '1px solid var(--border)',
              color: 'var(--text-muted)', fontFamily: 'var(--font-mono)',
            }}>⌘K</kbd>
          </div>

          <div style={{ flex: 1 }} />

          {/* Notifications */}
          <button className="btn btn-icon btn-ghost" style={{ position: 'relative' }} aria-label="Notifications">
            <Bell size={17} style={{ color: 'var(--text-secondary)' }} />
            <span style={{
              position: 'absolute', top: 2, right: 2,
              width: 8, height: 8, borderRadius: '50%',
              background: '#DC2626', border: '2px solid var(--bg)',
            }} />
          </button>

          {/* Role chip */}
          <div style={{
            display: 'flex', alignItems: 'center', gap: 6,
            padding: '4px 10px', borderRadius: 99,
            background: `${meta.color}12`, fontSize: 12, fontWeight: 500,
            color: meta.color,
          }}>
            <div style={{ width: 6, height: 6, borderRadius: '50%', background: meta.color }} />
            {meta.label}
          </div>
        </header>

        {/* Page content */}
        <main className="page">
          <Outlet />
        </main>

        {/* Footer */}
        <footer style={{
          padding: '12px 24px', fontSize: 12, color: 'var(--text-muted)',
          borderTop: '1px solid var(--border)', display: 'flex', justifyContent: 'space-between',
        }}>
          <span>© {new Date().getFullYear()} Microhaem · Mi-HRM v1.0.0</span>
          <a href="https://ess.microhaem.co.ug" style={{ color: 'var(--text-muted)' }}>
            ess.microhaem.co.ug
          </a>
        </footer>
      </div>

      {/* Mobile toggle — injected via CSS override */}
      <style>{`
        @media(max-width:768px){
          .topbar .btn-ghost[aria-label="Open menu"]{display:flex!important}
          .topbar div[style*="maxWidth"]{max-width:200px!important}
        }
      `}</style>
    </div>
  );
}
